import(/* webpackMode: "eager" */ "/builds/webdev/customer-projects/lachner-fe/app/global-error.tsx");
